import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react';
import { Card, CardTypes } from 'sealink/react-components/cards';

const NewsCardsCarousel = ({ newsEntries }) => (
  <div className="category-cards-carousel">
    <Swiper
      simulateTouch
      slidesPerView={1.3}
      spaceBetween={24}
      breakpoints={{
        992: {
          slidesPerView: 3,
        },
      }}
    >
      {newsEntries.map((entry, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <SwiperSlide key={index}>
          {Card({
            ...entry,
            hidePrice: true,
            className: 'card__container--no-border',
          })}
        </SwiperSlide>
      ))}
    </Swiper>
  </div>
);

export default NewsCardsCarousel;

NewsCardsCarousel.propTypes = {
  newsEntries: PropTypes.arrayOf(PropTypes.shape(CardTypes)),
};
